import { useMutation, gql } from '@apollo/client';

import { GET_PAGINATED_WORKING_CONDITIONS } from './get-paginated-working-conditions.hook';

export const UPDATE_INACTIVE_WORKING_CONDITION = gql`
  mutation updateInactiveWorkingCondition(
    $workingConditionId: ObjectId!
    $payload: UpdateInactiveWorkingConditionInput!
  ) {
    updateInactiveWorkingCondition(workingConditionId: $workingConditionId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdateInactiveWorkingCondition = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateInactiveWorkingCondition] = useMutation(UPDATE_INACTIVE_WORKING_CONDITION, {
    onCompleted: data => {
      if (data) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAGINATED_WORKING_CONDITIONS],
  });

  return updateInactiveWorkingCondition;
};
